import React, { useEffect, useState } from 'react'
import Field from 'front-end/src/components/common/form/field/Field'
import ResettableInput from 'front-end/src/components/common/form/input/ResettableInput'
import { t } from '@lingui/macro'

const SEARCH_DELAY = 250

export const SelectEntitiesFormViewSearch = ({
  defaultQuery,
  resetQuery,
  changeQuery
}) => {
  const [searchValue, setSearchValue] = useState(defaultQuery)

  useEffect(() => {
    const handler = setTimeout(() => {
      changeQuery(searchValue)
    }, SEARCH_DELAY)

    return () => {
      clearTimeout(handler)
    }
  }, [searchValue])

  return (
    <Field stretch>
      <ResettableInput
        autoFocus
        title={t`Name`}
        placeholder={t`Name...`}
        value={searchValue}
        onChange={setSearchValue}
        showResetButton={!!searchValue}
        showSearchIcon={true}
        onReset={() => {
          setSearchValue('')
          resetQuery()
        }}
      />
    </Field>
  )
}
